import { validateEnv } from './env.schema';

export interface EnvironmentConfig {
  services: {
    login: string;
    reach: string;
    account: string;
    reg: string;
    plm: string;
    cam: string;
    admin: string;
  };
  API_BASE_URL: string;
  AUTH_BASE_URL: string;
  CLIENT_ID: string;
  REDIRECT_URL: string;
  WSS_URL: string;
}

export function getEnvironmentConfig(): EnvironmentConfig {
  const env = validateEnv();

  return {
    API_BASE_URL: env.VITE_API_BASE_URL,
    AUTH_BASE_URL: env.VITE_AUTH_BASE_URL,
    CLIENT_ID: env.VITE_CLIENT_ID,
    REDIRECT_URL: env.VITE_REDIRECT_URL,
    WSS_URL: env.VITE_WSS_URL,
    services: {
      login: env.VITE_SERVICE_LOGIN,
      reach: env.VITE_SERVICE_REACH,
      account: env.VITE_SERVICE_ACCOUNT,
      reg: env.VITE_SERVICE_REG,
      plm: env.VITE_SERVICE_PLM,
      cam: env.VITE_SERVICE_CAM,
      admin: env.VITE_SERVICE_ADMIN,
    },
  };
}
